import React, { Component } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./_non-academic.scss";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import PreloaderTwo from "../../../preloader/PreloaderTwo";
import { Row, Col } from 'react-bootstrap';
import DailyAttendanceModal from "./dailyAttendanceModal";
import { Line } from "react-chartjs-2";
import { SectionCard, AttendanceStat } from './naComponents';
import { THEME, GRADIENTS } from './naTheme';

// ─── GraphQL Query (unchanged) ────────────────────────────────────────────────

const GET_ATTENDANCE_DETAILS = gql`
  query($student_mobile: String) {
    getStudentAttendance(student_mobile: $student_mobile) {
      year
      month {
        month no_of_present no_of_absent no_of_holidays no_of_days
        date { date is_holiday is_present dateStatus { attendance_type attended_status } }
      }
    }
  }
`;

// ─── Chart options (unchanged logic) ─────────────────────────────────────────

const chartOptions = {
  legend:  { display: false },
  scales: {
    xAxes: [{ ticks: { display: true } }],
    yAxes: [{ ticks: { display: true, beginAtZero: true, stepSize: 5 } }],
  },
  tooltips: {
    enabled: true, mode: 'index', intersect: false,
    callbacks: {
      label: (tooltipItem, data) =>
        data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel,
    },
  },
  layout: { padding: { left: 16, right: 16, top: 10, bottom: 10 } },
  hover:  { cursor: 'pointer' },
};

// ─── Component ────────────────────────────────────────────────────────────────

class NAAttendanceReports extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentMonth:     0,
      no_of_absent:     0,
      no_of_days:       0,
      no_of_holidays:   0,
      no_of_present:    0,
      currentYear:      0,
      currentMonthData: [],
      modalShow:        false,
      currentDateData:  [],
    };
  }

  componentDidMount() {
    const d = new Date();
    this.setState({ currentMonth: d.getMonth() + 1, currentYear: d.getFullYear() });
  }

  render() {
    const currentDate  = new Date();
    const currentMonth = currentDate.getMonth() + 1;

    const attendanceDetails = this.props.attendanceDetails;

    if (attendanceDetails.loading) return <PreloaderTwo />;
    if (attendanceDetails.error !== undefined) {
      alert("Server Error. " + attendanceDetails.error.message);
      return null;
    }

    // ── Data processing (unchanged logic) ──────────────────────────────────
    let graphData = [];

    if (attendanceDetails.getStudentAttendance.length > 0) {
      const filterAttendanceData = attendanceDetails.getStudentAttendance
        .filter(item => item?.year == this.state.currentYear)[0]
        ?.month.filter(item1 => item1?.month == this.state.currentMonth);

      const currentYear = new Date().getFullYear();
      graphData = attendanceDetails.getStudentAttendance
        .filter(item => item.year >= currentYear)[0]
        ?.month.filter(item1 => item1?.month >= 1 && item1?.month <= currentMonth);

      if (filterAttendanceData?.length > 0) {
        // State mutation in render preserved from original
        this.state.no_of_absent     = filterAttendanceData[0]?.no_of_absent;
        this.state.no_of_days       = filterAttendanceData[0]?.no_of_days;
        this.state.no_of_holidays   = filterAttendanceData[0]?.no_of_holidays;
        this.state.no_of_present    = filterAttendanceData[0]?.no_of_present;
        this.state.currentMonthData = filterAttendanceData;
      }
    }

    let monthAttendancePercentage = 0;
    if (this.state.no_of_days !== 0) {
      monthAttendancePercentage = (
        ((this.state.no_of_present + this.state.no_of_holidays) / this.state.no_of_days) * 100
      ).toFixed(2);
    }

    // ── Calendar helpers (unchanged logic) ────────────────────────────────
    const customTileContent = ({ date, view }) => {
      const colors = ["white", "tomato", "green", "#ffc107"];
      let index = 0, currentDisplay = false;

      const currentMonthData = this.state.currentMonthData[0]?.date
        ?.filter(item => item.date == date.getDate()) || [];

      currentMonthData.forEach(item => {
        if (item.is_holiday)                                     { index = 3; currentDisplay = true; }
        else if (item.is_present)                                { index = 2; currentDisplay = true; }
        else if (!item.is_present && item.dateStatus?.length > 0) { index = 1; currentDisplay = true; }
      });

      const customDotColor = colors[index];
      const minDate = new Date(2023, 5, 1);
      const maxDate = new Date();

      if (view === "month" && !date.isDisabled && date >= minDate && date <= maxDate && currentDisplay) {
        return (
          <div className="react-calendar__tile--custom-dot">
            <span style={{ "--custom-dot-color": customDotColor }} className="react-calendar__tile-dot" />
          </div>
        );
      }
      return null;
    };

    const tileClassName = ({ date, view }) => {
      if (view === "month") {
        const d = new Date();
        return date.getFullYear() !== d.getFullYear() || date.getMonth() !== d.getMonth()
          ? "react-calendar__tile--hidden"
          : "";
      }
      return "";
    };

    const changeDate = activeStartDate => {
      const m = activeStartDate.activeStartDate.getMonth() + 1;
      const y = activeStartDate.activeStartDate.getFullYear();
      this.setState({ currentMonth: m, currentYear: y });
    };

    const displayPopup = date => {
      const currentDate = this.state.currentMonthData[0]?.date?.filter(item => item.date == date.getDate()) || [];
      if (currentDate[0]?.dateStatus?.length > 0) {
        this.setState({ modalShow: true, currentDateData: currentDate[0]?.dateStatus });
      }
    };

    // ── Chart data (unchanged logic) ──────────────────────────────────────
    let monthNames = [], presentDays = [];
    if (graphData?.length > 0) {
      graphData.forEach(item => {
        const d = new Date();
        d.setMonth(item.month - 1);
        monthNames.push(d.toLocaleString('en-US', { month: 'short' }));
        presentDays.push(item.no_of_present);
      });
    }

    const chartData = {
      labels:   monthNames,
      datasets: [{
        label:       "Present Days",
        fill:        true,
        borderColor: THEME.primary,
        backgroundColor: 'rgba(91,95,239,0.08)',
        borderWidth: 2,
        pointStyle:  "circle",
        pointRadius: 5,
        pointBackgroundColor: THEME.primary,
        data:        presentDays,
      }],
    };

    const attendancePct = parseFloat(monthAttendancePercentage);
    const pctColor = attendancePct >= 75 ? THEME.success : THEME.danger;

    // ── Render ─────────────────────────────────────────────────────────────
    return (
      <div className="attendance_detials" style={{ paddingTop: '8px' }}>

        <Row>
          {/* ── Trend Chart ───────────────────────────────────────────── */}
          <Col sm={12} md={6} lg={6} style={{ marginBottom: '20px' }}>
            <SectionCard
              title="Monthly Present Days Trend"
              iconClass="fas fa-chart-line"
              headerBg={GRADIENTS.attendance}
            >
              <div className="chart-container" style={{ overflowX: 'auto', width: '100%' }}>
                <Line data={chartData} options={chartOptions} />
              </div>

              {/* Legend */}
              <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '14px', flexWrap: 'wrap' }}>
                {[
                  { color: '#10B981', label: 'Present' },
                  { color: '#EF4444', label: 'Absent'  },
                  { color: '#F59E0B', label: 'Holiday' },
                ].map(({ color, label }) => (
                  <div key={label} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#6B7280' }}>
                    <span style={{ width: 10, height: 10, borderRadius: '50%', background: color, display: 'inline-block' }} />
                    {label}
                  </div>
                ))}
              </div>
            </SectionCard>
          </Col>

          {/* ── Calendar + Stats ──────────────────────────────────────── */}
          <Col sm={12} md={6} lg={6} style={{ marginBottom: '20px' }}>
            <SectionCard
              title="Attendance Calendar"
              iconClass="fas fa-calendar-alt"
              headerBg={GRADIENTS.purple}
            >
              {/* Calendar */}
              <div className="calender_display">
                <Calendar
                  minDate={new Date(2023, 5, 1)}
                  maxDate={new Date()}
                  className="custom-calendar"
                  tileContent={customTileContent}
                  tileClassName={tileClassName}
                  onActiveStartDateChange={changeDate}
                  onChange={displayPopup}
                />
              </div>

              {/* Attendance % pill */}
              <div style={{ textAlign: 'center', margin: '14px 0 12px' }}>
                <span style={{
                  background:   pctColor === THEME.success ? THEME.successBg : THEME.dangerBg,
                  color:        pctColor,
                  padding:      '6px 18px',
                  borderRadius: '20px',
                  fontWeight:   700,
                  fontSize:     '14px',
                }}>
                  <i className="fas fa-percentage" style={{ marginRight: '5px', fontSize: '12px' }} />
                  {monthAttendancePercentage}% This Month
                </span>
              </div>

              {/* Stat chips */}
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <AttendanceStat
                  label="Total Classes"
                  value={this.state.no_of_days}
                  bg="rgba(91,95,239,0.10)"
                  color="#4338CA"
                />
                <AttendanceStat
                  label="Holidays"
                  value={this.state.no_of_holidays}
                  bg="rgba(245,158,11,0.10)"
                  color="#B45309"
                />
                <AttendanceStat
                  label="Present"
                  value={this.state.no_of_present}
                  bg="rgba(16,185,129,0.10)"
                  color="#047857"
                />
                <AttendanceStat
                  label="Absent"
                  value={this.state.no_of_absent}
                  bg="rgba(239,68,68,0.10)"
                  color="#B91C1C"
                />
              </div>
            </SectionCard>
          </Col>
        </Row>

        {/* Daily Attendance Modal (unchanged) */}
        <DailyAttendanceModal
          stateData={this.state.currentDateData}
          show={this.state.modalShow}
          onHide={() => this.setState({ modalShow: false })}
        />

      </div>
    );
  }
}

// ─── Apollo HOC (unchanged) ───────────────────────────────────────────────────

export default withRouter(
  compose(
    graphql(GET_ATTENDANCE_DETAILS, {
      options: props => ({
        variables:   { student_mobile: props.stateData.studentData.contact_no.toString() },
        fetchPolicy: 'network-only',
      }),
      name: "attendanceDetails",
    }),
  )(NAAttendanceReports)
);
